module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "TORLogo.bd732ad4.svg";